import React from "react";

function WorkExperience() {
  return (
    <div
      className="work-experience-card-container"
      style={{
        background: "#fff",
        borderRadius: "28px",
        width: "680px",
        maxWidth: "98vw",
        boxShadow: "0 4px 24px rgba(80,80,120,0.13)",
        padding: "40px 38px 30px 38px",
        margin: "0 auto",
        marginBottom: "34px",
        marginTop: "12px",
        textAlign: "left",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: 28,
          fontWeight: 700,
          marginBottom: 6,
          letterSpacing: -1,
        }}
      >
        <span
          role="img"
          aria-label="briefcase"
          style={{ fontSize: 32, marginRight: 12 }}
        >
          💼
        </span>
        Work Experience
      </div>

      <div
        style={{
          fontSize: 15,
          color: "#34345a",
          opacity: 0.85,
          marginTop: 30,
        }}
      >
        Experience working on AI, software, and technical projects.
      </div>

      <div
        style={{
          background: "#fafbfc",
          borderRadius: 18,
          padding: "18px 28px 16px 28px",
          marginBottom: 21,
          boxShadow: "0 1px 6px rgba(100,100,125,0.07)",
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 2 }}>
          Software Engineering Intern
        </div>
        <div
          style={{
            color: "#35355b",
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 4,
          }}
        >
          NVIDIA — Jan 2025 to Jul 2025
        </div>
        <div style={{ fontSize: 15.5, marginBottom: 10, color: "#1d1c25" }}>
          Developed a multimodal Retrieval-Augmented Generation (RAG) pipeline
          integrating diverse data sources to power an intelligent Slack support
          agent. Processed multimedia meeting data using Whisper, PyTesseract,
          and OpenCV. Automated continuous data ingestion into a vector database
          with cron jobs. Engineered agentic flows with LangGraph to reduce
          manual support interventions by 40%.
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {[
            "Python",
            "FastAPI",
            "MySQL",
            "LangChain",
            "LangGraph",
            "Qdrant",
            "SlackRTM",
            "Azure OpenAI",
            "MCP",
            "Docker",
          ].map((skill) => (
            <span
              key={skill}
              style={{
                background: "#e9f5f1",
                color: "#236749",
                fontWeight: 600,
                borderRadius: 9,
                padding: "4px 13px",
                fontSize: 15,
                marginBottom: 1,
              }}
            >
              {skill}
            </span>
          ))}
        </div>
      </div>

      <div
        style={{
          fontSize: 14,
          color: "#151517",
          opacity: 0.9,
          marginTop: 18,
          lineHeight: 1.5,
          maxWidth: 610,
        }}
      >
        <p>
          Driven by a builder’s mindset, I focus on shipping functional AI
          products that transform ideas into real-world solutions. My experience
          spans full-stack software engineering and Generative AI, cloud
          infrastructure, and building intelligent agent workflows.
        </p>
        <p>
          I am enthusiastic about learning new technologies, contributing to
          impactful projects, and pursuing opportunities that allow growth as a
          full-stack AI engineer.
        </p>
      </div>
    </div>
  );
}

export default WorkExperience;
